import React, {useEffect, useRef, useState} from 'react';
import './device-linking.css';
import logo from '../../../../../images/logos/squadDiskHR.png';
import {QRCodeCanvas} from "qrcode.react";
import SocketUtils from "../../socket-utils/socketUtils";
import {SquadflixLinkingApi} from "../../../../../apis/squadflix-linking-api/squadflix-linking-api";


const DeviceLinking = ({deviceId, setDeviceInfo}) => {
    const [code, setCode] = useState('____-____');
    const [linkingStatus, setLinkingStatus] = useState('waiting');
    const [linkingUser, setLinkingUser] = useState(null);
    const linking = useRef(false);

    const generateLinkCode = (deviceId, onCodeGenerated) => {
        SquadflixLinkingApi.generateLinkCode({deviceId}).then(response => {
            if (response?.code) {
                onCodeGenerated(response.code);
                const codeElement = document.querySelector('.device-linking-code');
                if (codeElement) {
                    codeElement.textContent = response.code.substring(0, 4) + '-' + response.code.substring(4, 8);
                }
                const expiresElement = document.querySelector('.device-linking-expires');
                if (expiresElement) {
                    let intervalId = null;
                    const updateSecondsLeft = () => {
                        const secondsLeft = Math.max(0, Math.floor((new Date(response.expiresAt).getTime() - Date.now()) / 1000));
                        expiresElement.textContent = `${secondsLeft}s`;
                        if (linking.current) {
                            clearInterval(intervalId);
                            return;
                        }
                        if (secondsLeft == 0) {
                            clearInterval(intervalId);
                            generateLinkCode(deviceId, onCodeGenerated);
                        }
                    }
                    updateSecondsLeft();
                    intervalId = setInterval(() => {
                        updateSecondsLeft();
                    }, 1000);
                }
            }
        }).catch(error => {
            console.error("Error generating link code:", error);
        });
    }

    useEffect(() => {
        generateLinkCode(deviceId, code => {
            setCode(code);
        });
    }, [deviceId]);

    useEffect(() => {
        const handleDeviceLinking = (data) => {
            setLinkingStatus("linking");
            setLinkingUser(data.user);
            linking.current = true;
        };
        const handleFinishLinking = (data) => {
            setLinkingStatus("linked");
            const user = data.user; // {uid, displayName}
            const device = data.device; // {deviceId, name, type, location, linkedAt, uid}
            localStorage.setItem("squadflixtv-deviceInfo", JSON.stringify(device))
            setDeviceInfo(device);
            console.log("finish_linking", data);
        }

        SocketUtils.on('device_linking', handleDeviceLinking);
        SocketUtils.on('finish_linking', handleFinishLinking);

        return () => {
            SocketUtils.off('device_linking', handleDeviceLinking);
            SocketUtils.off('finish_linking', handleFinishLinking);
        }
    }, []);

    return <div className="device-linking">
        <div className="device-linking__img">
            <div className="device-linking__img-container">
                <img width={600} src={logo} alt="Squadflix Logo" className="device-linking-logo"/>
                <span className="device-linking__img-container-label">SquadFlix TV</span>
            </div>
        </div>
        {
            linkingStatus === "linking" && linkingUser && <div className="device-linking-linking-container">
                <h1 className="device-linking-title pb-5">
                    Hola, {linkingUser.displayName}!
                </h1>
                <h2 className="device-linking-title">Dispositivo <small style={{
                    fontSize: '0.6em',
                }}>casi</small> enlazado</h2>
                <p className="device-linking-instructions pt-3">
                    Termina de configurar este dispositivo en SquadDisk.
                </p>
            </div>
        }
        {linkingStatus === "waiting" && <div className="device-linking-code-container">
            <div className="device-linking-text-container">
                <h1 className="device-linking-title pb-4">Enlazar dispositivo</h1>
                <p className="device-linking-instructions">
                    Escanea el QR con la cámara de tu teléfono
                    <br/>
                    <br/>
                    e ingresa el siguiente código
                </p>
                <div style={{}}>
                    <span className="device-linking-code">____-____</span>
                    <center>
                        <small className="device-linking-expires">0s</small>
                    </center>
                </div>
            </div>
            <div className="device-linking-qr-container">
                <QRCodeCanvas
                    value={"https://squaddisk.web.app/squadflix/link?code=" + code}
                    size={300}
                    level="H"
                    bgColor="#ffffff"
                    fgColor="#000000"
                    className="device-linking-qr"
                    includeMargin={true}
                />
                <div className="p-3 device-linking__text-normal">Escanea el QR o visita:</div>
                <a className="device-linking__text-normal" href="https://squaddisk.web.app/squadflix/link"
                   target="_blank"
                   rel="noopener noreferrer">
                    https://squaddisk.web.app/squadflix/link
                </a>
            </div>
        </div>}
        <div style={{
            textAlign: 'center',
            width: "100%",
            position: 'absolute',
            bottom: 10,
            fontSize: '0.7em',
            color: '#888',
            zIndex: 3
        }}>
            <div style={{textDecoration: "underline"}}>device id</div>
            {deviceId}
        </div>
    </div>;
}

export default DeviceLinking;
